import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
 import './ViewQRCertificationDetails.css';
import Certificate from './Certificate';
import { CERTIFICATE_URL } from '../../Services/courseService';
 
const ViewQRCertificationDetails = () => {
    const [certificateData, setCertificateData] = useState(null);
    const [loading, setLoading] = useState(true);
    const { userId, courseId } = useParams();
 
    useEffect(() => {
        const fetchCertificateData = async () => {
            try {
                const response = await axios.get(`${CERTIFICATE_URL}/certificates/data?userId=${userId}&courseId=${courseId}`);
               if(response.status===200){
                if (response.data) {
                    setCertificateData(response.data);
                }
               } 
            } catch (err) {
              } finally {
                setLoading(false);
            }
        };

        fetchCertificateData();
    }, [userId, courseId]);

    if (loading) {
        return <div>Loading certificate data...</div>;
    }

    if (!certificateData) {
        return <div  className="certificate-container">Certificate data is not available for this user for the selected course!</div>;
    }

    return (
        <div className="certificate-container">
             

            <Certificate userId={userId} courseId={courseId}/>
    
    
                 <Link to={`/enrolledCourse/${courseId}`} className="certificate-course-button">
                    Go to Course
                </Link>
         </div>
    );
    
        };
 export default ViewQRCertificationDetails;
